import type { ApiResponse } from '@/types'

const FORMSPREE_BASE = 'https://formspree.io/f'

export async function submitToFormspree(
  formId: string,
  data: Record<string, unknown>
): Promise<ApiResponse> {
  if (!formId || !formId.trim()) {
    return {
      success: false,
      message: 'Form ID is required',
      code: 'MISSING_FORM_ID',
    }
  }

  try {
    const response = await fetch(`${FORMSPREE_BASE}/${formId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (response.ok) {
      return {
        success: true,
        message: 'Submission received successfully',
        id: formId,
      }
    }

    // Try to parse error body, but don't fail if it's missing
    let errorBody: { error?: string } = {}
    try {
      errorBody = await response.json()
    } catch {
      // ignore
    }

    if (response.status === 422) {
      return {
        success: false,
        message: errorBody.error ?? 'Validation error',
        code: 'VALIDATION_ERROR',
      }
    }

    if (response.status === 429) {
      return {
        success: false,
        message: 'Rate limit exceeded. Please try again later.',
        code: 'RATE_LIMITED',
      }
    }

    return {
      success: false,
      message: errorBody.error ?? `Server error (${response.status})`,
      code: 'SERVER_ERROR',
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown network error'
    return {
      success: false,
      message: `Network error: ${message}`,
      code: 'NETWORK_ERROR',
    }
  }
}
